import React from "react";
import { useQuickSightEC2  } from "@/hooks/useEC2Reports";

const QuickSightAwsEC2Dashboard = () => {
  const { embedUrl } = useQuickSightEC2 ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsEC2Dashboard;
